export default __webpack_public_path__ + "static/media/14-min.0c79d0b8.jpg";